<div mat-dialog-title>
  <h1>ASM File Generation and Submission</h1>
</div>

<div mat-dialog-content>
  <div class="content-container flex flex-col gap-1">
    <div><h2>Summary Recap</h2></div>
    <div><span>Records: {{data.recordCount}}</span></div>
    <div><span>Exported Date: {{data.exportedDateTime}}</span></div>
  </div>

  <div class="content-container flex flex-col gap-4 mt-3">
    <div class="flex flex-row items-center">
      <mat-checkbox
        [checked]="checkboxSignal()"
        (change)="checkboxSignal.set($event.checked)">
        <span class="flex items-center gap-1">
          Update Status to <strong>ASM Submitted</strong>
          <mat-icon
            [matTooltip]="tooltipText"
            [matTooltipClass]="'app-tooltip'"
            matTooltipPosition="above"
            class="material-icons-outlined text-sm h-auto">info</mat-icon>
        </span>
      </mat-checkbox>
    </div>

    <div class="flex flex-row w-full h-auto">
      <mat-form-field appearance="outline" color="primary" class="w-full">
        <mat-label>Notes</mat-label>
        <textarea
          #notesArea
          matInput
          [formControl]="notesControl"
          [rows]="3"
          (keydown)="blockEditingPrefix($event)"
          (input)="enforcePrefix()"
          (click)="snapCaret()"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</div>

<mat-dialog-actions align="end">

  <button mat-flat-button class="secondary-button" (click)="handleClose()">Cancel</button>

  <button
    mat-flat-button
    class="primary-button"
    (click)="export()"
  >Export</button>

</mat-dialog-actions>